import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import Main from 'components/templates/Main';
import PATHS from 'constants/paths';
import HostComplaintDetail from '../components/HostComplaintDetail';
import {
  fetchHostComplaintRequest,
  hostRespondComplaintRequest,
  complaintsReset,
} from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

const HostComplaintDetailContainer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const error = useSelector(selectors.error);
  const isLoading = useSelector(selectors.hostIsLoading);
  const isUpdating = useSelector(selectors.isUpdating);
  const conflict = useSelector(selectors.conflict);
  const complaint = useSelector(selectors.hostDetail);
  const success = useSelector(selectors.success);

  React.useEffect(() => {
    dispatch(fetchHostComplaintRequest({ id }));
    return () => dispatch(complaintsReset());
  }, [id]);

  const handleRespond = (data) => {
    dispatch(
      hostRespondComplaintRequest({ id, data: { ...data, updated_at: complaint.updated_at } }),
    );
  };

  const title = (
    <div>
      <IconButton color="inherit" component={Link} to={PATHS.hostComplaints.root}>
        <ArrowBack />
      </IconButton>
      <FormattedMessage id="complaints.detail" defaultMessage="Complaint" />
      {complaint && ` #${complaint.id}`}
    </div>
  );

  return (
    <Main title={title}>
      <HostComplaintDetail
        complaint={complaint}
        isLoading={isLoading}
        isUpdating={isUpdating}
        conflict={conflict}
        onRespond={handleRespond}
      />
      <Success success={success} />
      <Errors errors={error} />
    </Main>
  );
};

export default HostComplaintDetailContainer;
